export const SOCIAL_CONFIG = {
  ru: {
    max: 'https://max.ru/u/f9LHodD0cOL212hgcGDlgk-a9sxIOfhl_5l3r6mNmtpYY8KEdB5IiFmS9NU',
    telegram: '',
    whatsapp: '',
  },
  kz: {
    telegram: 'https://t.me/geodata2gis_kz',
    whatsapp: 'https://wa.me/77710834813',
  },
  com: undefined,
  am: undefined,
  ge: undefined,
  tj: undefined,
};

export const MAIL_CONFIG = {
  ru: 'dev@2gis.ru',
  com: 'dev@2gis.ru',
  am: 'dev@2gis.ru',
  ge: 'dev@2gis.ru',
  tj: 'dev@2gis.ru',
  kz: 'dev@2gis.ru',
};

export const LOCALE_PHONE_NUMBERS_CONFIG = {
  ru: {
    href: '88002003600',
    label: '8 800 200-36-00',
  },
  kz: {
    href: '+77719290107',
    label: '+7 771 929-01-07',
  },
  com: undefined,
  am: undefined,
  ge: undefined,
  tj: undefined,
};

export const PRIMARY_PHONE_NUMBER_BY_DOMAIN_AND_LOCALE_CONFIG = {
  ru: {
    ru: {
      href: '+79665000050',
      label: '+7 966 500-00-50',
    },
    kz: {
      href: '+79665000050',
      label: '+7 966 500-00-50',
    },
    en: {
      href: '+79665000050',
      label: '+7 966 500-00-50',
    },
    am: {
      href: '+79665000050',
      label: '+7 966 500-00-50',
    },
    ge: {
      href: '+79665000050',
      label: '+7 966 500-00-50',
    },
    tg: {
      href: '+79665000050',
      label: '+7 966 500-00-50',
    },
  },
  kz: {
    ru: {
      href: '+77710834813',
      label: '+7 771 083-48-13',
    },
    kz: {
      href: '+77710834813',
      label: '+7 771 083-48-13',
    },
    en: undefined,
    am: undefined,
    ge: undefined,
    tg: undefined,
  },
  com: {
    ru: undefined,
    kz: undefined,
    en: undefined,
    am: undefined,
    ge: undefined,
    tg: undefined,
  },
  am: {
    ru: undefined,
    kz: undefined,
    en: undefined,
    am: undefined,
    ge: undefined,
    tg: undefined,
  },
  ge: {
    ru: undefined,
    kz: undefined,
    en: undefined,
    am: undefined,
    ge: undefined,
    tg: undefined,
  },
  tj: {
    ru: undefined,
    kz: undefined,
    en: undefined,
    am: undefined,
    ge: undefined,
    tg: undefined,
  },
};

export const MAIL_CONFIG_BY_DOMAIN_AND_LOCALE = {
  ru: {
    ru: 'dev@2gis.ru',
    kz: 'dev@2gis.ru',
    en: 'dev@2gis.ru',
    am: 'dev@2gis.ru',
    ge: 'dev@2gis.ru',
    tg: 'dev@2gis.ru',
  },
  kz: {
    ru: 'dev@2gis.ru',
    kz: 'dev@2gis.ru',
    en: undefined,
    am: undefined,
    ge: undefined,
    tg: undefined,
  },
  com: {
    ru: undefined,
    kz: undefined,
    en: undefined,
    am: undefined,
    ge: undefined,
    tg: undefined,
  },
  am: {
    ru: undefined,
    kz: undefined,
    en: undefined,
    am: undefined,
    ge: undefined,
    tg: undefined,
  },
  ge: {
    ru: undefined,
    kz: undefined,
    en: undefined,
    am: undefined,
    ge: undefined,
    tg: undefined,
  },
  tj: {
    ru: undefined,
    kz: undefined,
    en: undefined,
    am: undefined,
    ge: undefined,
    tg: undefined,
  },
};
